module.exports = __webpack_public_path__ + "assets/2e357fe0bef6244dbd1ddffafcbf170d.png";